import React, { Fragment, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../../App/stores/RootStore'
import Moment from "react-moment";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Button, Card, Divider, Form, Icon, Label} from "semantic-ui-react";
import RequestReviewNoteForm from "../../../../notes/form/RequestReviewNote/RequestReviewNoteForm";

const RequestReviewNotes: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { user } = rootStore.userStore
    const { requestReviewNotesById, deleteRequestReviewNote, loadRequestReviewNotes } = rootStore.requestReviewNoteStore;
    const { openModal } = rootStore.modalStore;

    return (
        <Fragment>
            <Card fluid>
                <Card.Content>
                    <Card.Header>
                        Review Notes
                    </Card.Header>
                    <Divider />
                    <Card.Description>
                        {requestReviewNotesById.map(([group, requestReviewNotes]) => (
                            <Fragment key={group}>
                                {requestReviewNotes.map(note => (
                                    <Form.Group key={note.id}>
                                        <Form.Field id={note.id} className={'note-field'}>
                                            <Button size='tiny'
                                                className={'rl-btn'}
                                                disabled={note.createdById === user?.id ? false : true}
                                                onClick={() => openModal(
                                                    <RequestReviewNoteForm
                                                        requestReviewNoteId={note.id}
                                                        noteType={note.noteType}
                                                        note={note.note}
                                                        requestReviewId={note.requestReviewId} />)} >
                                                <Icon name="edit" />
                                            </Button>
                                            <Button size='tiny'
                                                color={'red'}
                                                disabled={note.createdById !== user?.id}
                                                onClick={() => deleteRequestReviewNote(note.id)
                                                    .then(r => loadRequestReviewNotes(note.requestReviewId))}>
                                                <Icon name="delete" />
                                            </Button>
                                            <Label content={note.note} style={{ maxWidth: '45%' }} />
                                            {note.createdByName} - <Moment format={'MMM D YYYY'} date={note.dateCreated} />
                                        </Form.Field>
                                    </Form.Group>
                                ))}
                            </Fragment>
                        ))}
                    </Card.Description>
                </Card.Content>
            </Card>
        </Fragment>
    )
}
export default observer(RequestReviewNotes);